import { useEffect, useState } from "react";

export type MediaStatus = "idle" | "available" | "denied" | "in-use" | "not-found" | "error";

export function useMediaAvailability() {
	const [cameraStatus, setCameraStatus] = useState<MediaStatus>("idle");
	const [micStatus, setMicStatus] = useState<MediaStatus>("idle");

	useEffect(() => {
		async function checkMedia(kind: "video" | "audio") {
			const setStatus = (status: MediaStatus) =>
				kind === "video" ? setCameraStatus(status) : setMicStatus(status);

			try {
				const constraints = kind === "video" ? { video: true } : { audio: true };
				const stream = await navigator.mediaDevices.getUserMedia(constraints);

				setStatus("available");
				stream.getTracks().forEach((track) => track.stop());
			} catch (error: any) {
				const errorMap: Record<string, MediaStatus> = {
					NotAllowedError: "denied",
					NotFoundError: "not-found",
					NotReadableError: "in-use",
				};

				setStatus(errorMap[error.name] ?? "error");
			}
		}

		checkMedia("video");
		checkMedia("audio");
	}, []);

	return { cameraStatus, micStatus };
}
